"use client";

import HeaderBackground from "@/components/ui/header-background";
import ContactForm from "./components/contacts-form";
import ContactInfo from "./components/contacts-info";
import S from "./index.module.scss";

const ContactsView = () => {
  return (
    <>
      <HeaderBackground type="black" />
      <div className={S.wrapper}>
        <ContactInfo />
        <ContactForm />
      </div>
    </>
  );
};

export default ContactsView;
